<template>
  <div id="body_T" v-if="allBetEvent.od[plytyp]">
    <!------------------------ FT TG ------------------------>
    <template v-for="btype in btypes" v-if="allBetEvent.od[plytyp][btype]">
        <table id="model_T" border="0" cellpadding="0" cellspacing="0" class="more_table2">
          <tbody>
            <!--tr style="height:2px"><td class="emptyrow"  :class="{isrb: allBetEvent.event_rb==1}" colspan="4"></td></tr-->
            <template v-for="(subMatch, subMatchKey) in (allBetEvent.sub + 1)">
              <tr v-if="subMatchKey == 0">
                <th class="more_title4" colspan="4" style="padding-left: 0px;padding-top: 0px;" @click="showLeg()">
                  <button id="triggertoggle" class="trigger toggle-primary" :class="show ? 'icon-open' : 'icon-close'"></button>

                  <span style="float: left; padding-left: 5px;" >{{ sportAllBetLang['ALL_BET.SUBHEADER_TG'] }}</span>
                  <span v-if="plytyp==firstHtPlyType" class="more_og2">{{ sportAllBetLang['ALL_BET.SUBHEADER_1HT'] }}</span>
                  <span class="more_og2" v-if="isSpecial">&nbsp;({{ sportAllBetLang['ALL_BET.LBL_SPECIALS'] }})</span>
                  
                  <!-- <span class="more_star_bg" v-if="!myMarket" @click="addToMyMarket(plytyp,btype)">
                    <span id="star_R" name="star_R" class="star_down" :title="sportAllBetLang['ALL_BET.MSG_CLICK_ADD_TO_MYMARKET']"></span>
                  </span>
                  <span class="more_star_bg" v-else @click="removeFromMyMarket(plytyp,btype)">
                    <span id="star_R" name="star_R" class="star_up" :title="sportAllBetLang['ALL_BET.MSG_CLICK_ADD_TO_MYMARKET']"></span>
                  </span> -->
                </th>
              </tr>
              <template v-if="show">
              <template v-if="subMatchKey == 0">
                <tr>
                  <th class="allbetheader header" width="25%" :class="highlight('teamtg01')" :title="sportAllBetLang[tgBetTitle[plytyp][0]]">
                    <span class="">{{ sportAllBetLang[tgBetTitle[plytyp][0]] }}</span>
                  </th>
                  <th class="allbetheader header" width="25%" :class="highlight('teamtg23')" :title="sportAllBetLang[tgBetTitle[plytyp][2]]">
                    <span class="">{{ sportAllBetLang[tgBetTitle[plytyp][1]] }}</span>
                  </th>
                  <th class="allbetheader header" width="25%" :class="highlight('teamtg46')" :title="sportAllBetLang[tgBetTitle[plytyp][2]]">
                    <span class="">{{ sportAllBetLang[tgBetTitle[plytyp][2]] }}</span>
                  </th>
                  <th class="allbetheader header" width="25%" :class="highlight('teamtg7')" :title="sportAllBetLang[tgBetTitle[plytyp][3]]">
                    <span class="">{{ sportAllBetLang[tgBetTitle[plytyp][3]] }}+</span>
                  </th>
                </tr>

                <tr class="trow">
                  <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" width="25%" @click="selectCell($event,'teamtg01')">
                    <div class="betArea" style="margin:auto;width:100px;">
                      <span class="m_red" :title="plytyp == '2' ? sportAllBetLang['ALL_BET.LBL_0'] : sportAllBetLang['ALL_BET.LBL_01']">
                        <cstgftht :event="allBetEvent" :score="'tg01'" :plyType="plytyp" :betType="btype" ref="teamtg01"/>
                      </span>
                    </div>
                  </td>
                  <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" width="25%" @click="selectCell($event,'teamtg23')">
                    <div class="betArea" style="margin:auto;width:100px;">
                      <span class="m_red" :title="plytyp == '2' ? sportAllBetLang['ALL_BET.LBL_1'] : sportAllBetLang['ALL_BET.LBL_23']">
                        <cstgftht :event="allBetEvent" :score="'tg23'" :plyType="plytyp" :betType="btype" ref="teamtg23"/>
                      </span>
                    </div>
                  </td>
                  <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" width="25%" @click="selectCell($event,'teamtg46')">
                    <div class="betArea" style="margin:auto;width:100px;">
                      <span class="m_red" :title="plytyp == '2' ? sportAllBetLang['ALL_BET.LBL_2'] : sportAllBetLang['ALL_BET.LBL_46']">
                        <cstgftht :event="allBetEvent" :score="'tg456'" :plyType="plytyp" :betType="btype" ref="teamtg46"/>
                      </span>
                    </div>
                  </td>
                  <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" width="25%" @click="selectCell($event,'teamtg7')">
                    <div class="betArea" style="margin:auto;width:100px;">
                      <span class="m_red" :title="plytyp == '2' ? sportAllBetLang['ALL_BET.LBL_3more'] : sportAllBetLang['ALL_BET.LBL_7more']">
                        <cstgftht :event="allBetEvent" :score="'tg7'" :plyType="plytyp" :betType="btype" ref="teamtg7"/>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
              </template>
            </template>
          </tbody>
        </table>
    </template>
  </div>
</template>

<script>

  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'

  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent : null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            btypes: [allBetMixin.data().tgBetType, allBetMixin.data().rtgBetType],
            tgBetTitle : {
              '1' : ['ALL_BET.LBL_01','ALL_BET.LBL_23','ALL_BET.LBL_46','ALL_BET.LBL_7more'],
              '2' : ['ALL_BET.LBL_0','ALL_BET.LBL_1','ALL_BET.LBL_2','ALL_BET.LBL_3more']
            },
            show: true,
        }
    },
    methods: {
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      addToMyMarket(plytyp,tgBetType) {
        if(this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp,tgBetType) {
        if(this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/fullTime-tg.vue